module.exports = "<div class=\"user-details-component user-job-edit\">\n  <div class=\"title\">\n    <h4>\n      <span class=\"fa fa-briefcase\"></span>\n      JOB PRICING EDIT\n    </h4>\n  </div>\n  <div class=\"details-grid\">\n    <div kendo-grid=\"vm.grid\" k-options=\"vm.gridOptions\"></div>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/Components/user-job-edit/user-job-edit.html
 ** module id = 707
 ** module chunks = 0
 **/